<template>
  <carousel
    v-bind:scrollPerPage="true"
    v-bind:autoplay="true"
    v-bind:autoplayTimeout="5000"
    v-bind:speed="3000"
    v-bind:loop="true"
    v-bind:centerMode="true"
    v-bind:per-page-custom="[
      [280, 1],
      [480, 1],
      [780, 2],
      [1024, 3],
    ]"
  >
    <slide class="px-5" v-for="(item, index) in elements" :key="index">
      <div class="font-lato max-h-100">
        <div>
          <img
            v-if="app.webp_support"
            class="object-cover w-full h-60"
            style="height: 19rem"
            :src="item.image_webp_url"
            :alt="item.hotel_name"
            width="345"
            height="304"
          />
          <img
            v-else
            class="object-cover w-full h-60"
            style="height: 19rem"
            :src="item.image_url"
            :alt="item.hotel_name"
            width="345"
            height="304"
          />
        </div>

        <div class="bottom-0 w-full bg-black-homepage p-2 h-40">
          <h4 class="text-center text-orange p-2 uppercase">
            {{ item.title }}
          </h4>
          <div class="text-white text-xs">
            <a
              class="hover:text-orange hover:underline hover:underline-offset-2"
              :href="item.hotel_url"
              tabindex="-1"
              >{{ item.hotel_name }}</a
            >
            |
            <a
              class="hover:text-orange hover:underline hover:underline-offset-2"
              :href="item.country_url"
              tabindex="-1"
              >{{ item.country_name }}</a
            >
          </div>
          <div class="text-white text-xs">
            Available: {{ item.start }}- {{ item.end }}
          </div>
          <div class="p-4">
            <a
              :href="item.book_now_url"
              class="bg-orange text-white p-2 text-xs uppercase"
              v-if="app.is_user_logged"
              >SEE DEAL</a
            >
            <a
              :href="item.book_now_url"
              class="bg-orange text-white p-2 text-xs uppercase"
              v-else
            >
              Sign Up & See Deal</a
            >
          </div>
        </div>
      </div>
    </slide>
  </carousel>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
export default {
  props: ["elements", "app"],
  components: {
    Carousel,
    Slide,
  },
};
</script>
